import * as vp from 'vopay';
import { Box, ElementContainer, TextField, formattedCurrency } from 'vopay';
import { JSX, FunctionComponent } from 'react';
import styles from '../../Group.module.scss';
import { useTranslation } from 'react-i18next';

type KeyValuePair = {
  display: string;
  value: JSX.Element;
  visible: boolean;
};

type ContactListType = {
  [key: number]: {
    Account: string;
    Amount: string;
    ClientReferenceNumber: string;
    Currency: string;
    FirstName: string;
    IsActive: string;
    LastName: string;
    Message: string;
    Token: string;
  };
};

type GroupTableProps = {
  group: vp.ContactGroupsLists;
  type: string;
  isReview: boolean;
  groupList: ContactListType;
};

type FC = FunctionComponent<GroupTableProps>;

const GroupTable: FC = ({ group, type, isReview, groupList }: GroupTableProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Details.Table' });

  const NumOfTransaction = Object.values(groupList || {}).filter((data) => Number(data.Amount) > 0).length;
  const Amount = Object.values(groupList || {})
    .map((data) => Number(data.Amount))
    .reduce((res, num) => res + num, 0)
    .toFixed(2);

  const GroupTableRows: KeyValuePair[] = [
    {
      display: t('name'),
      value: (
        <TextField
          name="group-name"
          variant="background"
          placeholder={group.GroupName || ''}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
      visible: true,
    },
    {
      display: t('description'),
      value: (
        <TextField
          name="description"
          variant="background"
          placeholder={group.Description || ''}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
      visible: true,
    },
    {
      display: t('product'),
      value: (
        <span className={styles.upperCase}>
          <TextField
            name="product"
            variant="background"
            placeholder={group.Service || ''}
            placeholderColor
            disabled
            onBlur={() => {}}
            onChange={() => {}}
          />
        </span>
      ),
      visible: true,
    },
    {
      display: t('Service.label'),
      value: (
        <span className={styles.capitalize}>
          <TextField
            name="service"
            variant="background"
            placeholder={type === 'Payment' ? t('Service.creditPlaceholder') : t('Service.debitPlaceholder')}
            placeholderColor
            disabled
            onBlur={() => {}}
            onChange={() => {}}
          />
        </span>
      ),
      visible: !!isReview,
    },
    {
      display: t('numberOfTransactions'),
      value: (
        <TextField
          name="NumberOfTransactions"
          variant="background"
          placeholder={String(NumOfTransaction)}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
      visible: !!isReview,
    },
    {
      display: t('amount'),
      value: (
        <TextField
          name="Amount"
          variant="background"
          placeholder={`$${formattedCurrency(Amount)}`}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
      visible: !!isReview,
    },
    {
      display: t('currency'),
      value: (
        <TextField
          name="currency"
          variant="background"
          placeholder={group.ACTCurrencies_ID === '1' ? 'USD' : 'CAD'}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
      visible: true,
    },
  ];

  return (
    <Box pb="lg" mb="md" gap="sm" jc="sb" width="100%" wrap="wrap">
      {GroupTableRows.filter(({ visible }) => visible).map(({ display, value }) => (
        <Box flx="col" width="49%" key={display}>
          <ElementContainer key={display} label={display} color="grey" required={false} input={value} />
        </Box>
      ))}
    </Box>
  );
};

export default GroupTable;
